import React from "react";

import { ILanguageType } from "@/types/GlobalTypes";
import { getBasePcode } from "./gamePcode";

export default function getRoadmapText(pcode: string, filter: string, langdata: ILanguageType, multiline: boolean = false) {
    if (!langdata)
        return null;

	const multilineBreak = multiline ? <br/> : null;
	
    const roadmapTexts: {[pcode: string]: {[filter: string]: JSX.Element}} = {
        "m20": {
                "circle-square-others" : <div>
                    <div className="sl-roadmap-square sl-blue roadmap-icon" /> { langdata["txt_square"] }
                    <div className="sl-roadmap-circle sl-roadmap-red roadmap-icon" /> { langdata["txt_circle"] }
                    <div className="sl-roadmap-circle sl-green roadmap-icon" /> { langdata["txt_others"] }
                </div>
            },
        
        "p6" : {
            "red-black": <div>
                    <div className="sl-roadmap-diamond sl-roadmap-red roadmap-icon" /> { langdata["txt_red"] } { multilineBreak }
                    <div className="sl-roadmap-diamond sl-roadmap-black roadmap-icon" /> { langdata["txt_black"] } { multilineBreak }
                </div>,
            "odd-even": 
                <div>
                    <div className="sl-roadmap-square sl-roadmap-red roadmap-icon" /> { langdata["txt_odd"] } { multilineBreak }
                    <div className="sl-roadmap-square sl-roadmap-black roadmap-icon" /> { langdata["txt_even"] } { multilineBreak }
                </div>, 
            "small-big":
                <div>
                    <div className="sl-roadmap-circle sl-roadmap-red roadmap-icon" /> { langdata["txt_small"] } { multilineBreak }
                    <div className="sl-roadmap-circle sl-roadmap-black roadmap-icon" /> { langdata["txt_big"] } { multilineBreak }
                </div>
            },
        
        "p12": {
            "small-big":
                <div>
                    <div className="sl-roadmap-circle sl-roadmap-red roadmap-icon" /> {langdata["txt_small"]}
                    <div className="sl-roadmap-circle sl-roadmap-black roadmap-icon" /> {langdata["txt_big"]}
                </div>,
            "odd-even":
                <div>
                    <div className="sl-roadmap-square sl-roadmap-red roadmap-icon" /> { langdata["txt_odd"] }
                    <div className="sl-roadmap-square sl-roadmap-black roadmap-icon" /> { langdata["txt_even"] }
                </div>
            },
        
        "m10": {
            "head-tail":
                <div>
                    <div className="sl-roadmap-circle sl-roadmap-red roadmap-icon" /> { langdata["txt_head"] }
                    <div className="sl-roadmap-circle sl-blue roadmap-icon" /> { langdata["txt_tail"] }
                </div>,
            "left-right": 
                <div>
                    <div className="sl-roadmap-circle sl-roadmap-red roadmap-icon" /> { langdata["txt_left"] }
                    <div className="sl-roadmap-circle sl-roadmap-black roadmap-icon" /> { langdata["txt_right"] }
                </div>
            },
        
        "m11": {"red-white":
                <div>
                    <div className="sl-roadmap-circle sl-roadmap-red roadmap-icon" /> { langdata["txt_red"] }
                    <div className="sl-roadmap-circle sl-roadmap-white roadmap-icon" /> { langdata["txt_white"] }
                </div>
            },
    
        "m13": { "small-big": 
                <div>
                    <div className="sl-roadmap-circle sl-roadmap-red roadmap-icon" /> { langdata["txt_small"] }
                    <div className="sl-roadmap-circle sl-roadmap-black roadmap-icon" /> { langdata["txt_big"] }
                </div>
            },
        
        "m16": {
            "player-banker": 
                <div>
                    <div className="sl-roadmap-diamond sl-blue roadmap-icon" /> { langdata["txt_player"] }
                    <div className="sl-roadmap-diamond sl-roadmap-red roadmap-icon" /> { langdata["txt_banker"] }
                </div>,
            "odd-even": 
                <div>
                    <div className="sl-roadmap-square sl-roadmap-red roadmap-icon" /> { langdata["txt_odd"] }
                    <div className="sl-roadmap-square sl-roadmap-black roadmap-icon" /> { langdata["txt_even"] }
                </div>,
            "small-big": 
                <div>
                    <div className="sl-roadmap-circle sl-roadmap-red roadmap-icon" /> { langdata["txt_small"] }
                    <div className="sl-roadmap-circle sl-roadmap-black roadmap-icon" /> { langdata["txt_big"] }
                </div>
            },
        
        "m22": {
            "big-road":
                <div>Big Road</div>
        },
        
        "m25": {
            "bead-road":
                <div>Bead Road</div>,
            "big-road":
                <div>Big Road</div>
        },
    
        "m32": {
            "player-tie-banker":
                <div>Player Tie Banker</div>
        },

		"m39": {
			"red-tie-blue":
				<div>Red Blue</div>
		}
    };

    //Duplicate same roadmap texts
    const clonePcodes = {
        "m6": "p6",
        "p9": "p6",
        "p7": "p6",
        "m14": "p6",
        "m35": "p6",
        "m36": "p6",
        
        "m8": "p12",
        "m31": "p12",
        "m37": "p12",

		"m21": "m20",

        "m23": "m22",
        "m25": "m22",
        "m28": "m22",
        "m38": "m22",
		"m40": "m22"
    };

    const basePcode = getBasePcode(pcode),
        selectedPcode = (
			basePcode in clonePcodes
			? clonePcodes[basePcode]
			: basePcode
		);

    if (roadmapTexts[selectedPcode])
        return roadmapTexts[selectedPcode][filter];
    else {
        console.warn("gRT pcode: " + selectedPcode + ", filter: " + filter);
        return null;
    }
}